export const UPDATE_PACKAGE_BOXES_SUCCESS = 'UPDATE_PACKAGE_BOXES_SUCCESS';
export const UPDATE_PACKAGE_BOXES_REQUEST = 'UPDATE_PACKAGE_BOXES_REQUEST';
export const UPDATE_PACKAGE_BOXES_FAILURE = 'UPDATE_PACKAGE_BOXES_FAILURE';
export const updatePackageBoxesSuccess = (payload) => ({
    type: UPDATE_PACKAGE_BOXES_SUCCESS,
    payload,
});
export const updatePackageBoxesRequest = (payload) => ({
    type: UPDATE_PACKAGE_BOXES_REQUEST,
    payload
});
export const updatePackageBoxesFailure = (payload) => ({
    type: UPDATE_PACKAGE_BOXES_FAILURE,
    payload,
});
